const data = [
  {
    title: "Digital Content",
    description: `Frictionless micro-payments and global distribution for content platforms. 
      Webtoon studios, creators, and IP partners use SWITCH to unlock:`,
    list: [
      "per-episode micro-transactions",
      "gasless, instant UX",
      "automated royalty & revenue sharing",
    ],
  },
  {
    title: "Mobility",
    description: `Smart escrow infrastructure for rentals — ideal for mobility, camera, equipment, and toy ecosystems. 
      Partners leverage SWITCH for:`,
    list: [
      "automated deposit locking",
      "verifiable damage-claim logic",
      "time-based payout automation",
    ],
  },
  {
    title: "Retail",
    description: `Next-generation loyalty and transparent settlement for physical businesses. 
      Retail and F&B partners enable:`,
    list: [
      "on-chain membership programs",
      "unified point & reward systems",
      "store-owner–friendly settlement",
    ],
  },
  {
    title: "Commerce",
    description: `Inventory-backed commerce flows for marketplaces and distributors. 
      Publicly listed manufacturers and retail partners integrate SWITCH to unlock:`,
    list: [
      "verified real-world inventory indexing",
      "automated escrow & payouts",
      "cross-chain liquidity routing",
    ],
  },
];

export default function Section3() {
  return (
    <section id="section3" className="relative z-10 w-full flex flex-col items-center justify-center mb-[80px] md:mb-[130px] lg:mb-[150px]">
      <div className="container mx-auto px-4">
        <div className="flex flex-col mb-[70px]">
          <h2 className="text-[52px] font-normal text-white tracking-tight">
            SWITCH Ecosystem
          </h2>
          <h3 className="text-[18px] text-white mb-[70ox] tracking-tight">
            Real-world industries powered by partnerships with listed companies,
            major content studios, and retail networks all unified through
            verifiable payments and automated settlement
          </h3>
        </div>
        <div className="flex overflow-x-auto snap-x snap-mandatory md:grid md:grid-cols-1 lg:grid-cols-2 gap-8 pb-4 md:pb-0 scrollbar-hide -mx-4 px-4 md:mx-0 md:px-0">
          {data.map((item, index) => (
            <div
              key={index}
              className="relative flex flex-col gap-4 p-8 rounded-lg border border-white text-white transition-all duration-300 hover:bg-white hover:text-black overflow-hidden group w-[calc(100vw-2rem)] md:w-auto flex-shrink-0 snap-start md:snap-none"
              style={{
                background:
                  "linear-gradient(103.9deg, rgba(250, 250, 250, 0.2) 4.77%, rgba(246, 246, 246, 0) 99.05%)",
              }}
            >
              <div
                className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
                style={{
                  backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)' opacity='0.4'/%3E%3C/svg%3E")`,
                  backgroundSize: "200px 200px",
                  backgroundColor: "white",
                }}
              ></div>
              <h4 className="text-[34px] font-normal relative z-10">
                {item.title}
              </h4>
              <p className="text-[18px] relative z-10 whitespace-pre-line">
                {item.description}
              </p>
              <ul className="list-disc list-inside pl-4 text-[18px] relative z-10">
                {item.list.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
